import React from 'react'

export enum PortfolioWizardStepNames {
  type = 'type',
  property = 'property',
  applications = 'applications',
  tenants = 'tenants',
  owners = 'owners',
  lease = 'lease',
  rent = 'rent',
  settings = 'settings',
  commission = 'commission',
  invoices = 'invoices',
  renewal = 'renewal',
  termination = 'termination',
  activation = 'activation',
}

export type PortfolioWizardStep = {
  name: PortfolioWizardStepNames
  route: string
  label: string
  activeWhen?: string[]
  hasCheckmark: boolean
  isOptional?: boolean
  // When true the step stays clickable in the draft wizard even if earlier steps
  // aren't complete (e.g. Internal), bypassing the sequential-unlock gating.
  isAlwaysAccessible?: boolean
  progress: number
  Icon: React.FC
  isVisible: boolean
}
